import { render, staticRenderFns } from "./organization-box.vue?vue&type=template&id=2c186146&"
import script from "./organization-box.vue?vue&type=script&lang=js&"
export * from "./organization-box.vue?vue&type=script&lang=js&"
import style0 from "./organization-box.vue?vue&type=style&index=0&id=2c186146&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports